/** @jsx jsx */
import { jsx } from '@emotion/core';

import Status from './Status';
import { getServerErrorBlock } from './utils';

import type { ValidationResultSetWrapper } from 'app/developer-v3/types';
import type { SemVer } from 'app/developer-v3/types/version';
type Props = {
  isSuccess: boolean;
  isFailure: boolean;
  onClose: () => void;
  onConfirm: () => void;
  toVersion: SemVer;
  errors?: string | Array<string> | ValidationResultSetWrapper;
};

const CloneFinished = ({
  isSuccess,
  isFailure,
  onClose,
  onConfirm,
  toVersion,
  errors,
}: Props) => (
  <Status
    cancelButtonLabel="Close"
    confirmButtonLabel={isSuccess ? 'Edit' : 'Get Help'}
    description={
      isSuccess
        ? "You can now edit this new version of your integration, and promote it as your integration's default version when finished."
        : 'This may be something you can fix!'
    }
    heading={
      isSuccess
        ? `Version ${toVersion} was Cloned Successfully`
        : 'There was a Problem'
    }
    isSuccess={isSuccess}
    onClose={onClose}
    onConfirm={onConfirm}
  >
    {isFailure && errors && getServerErrorBlock(isFailure, errors)}
  </Status>
);

export default CloneFinished;
